export const deleteRuEuMapping = (builder) => ({
    deleteRuEuMapping: builder.mutation({
        query: (body) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/remove_eu_from_eru',
                method: 'DELETE',
                body: body,
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': token
                },
              };
        },
    }),
});
